import { render, staticRenderFns } from "./team_settings.vue?vue&type=template&id=52208d67&scoped=true"
import script from "./team_settings.vue?vue&type=script&lang=js"
export * from "./team_settings.vue?vue&type=script&lang=js"
import style0 from "./team_settings.vue?vue&type=style&index=0&id=52208d67&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52208d67",
  null
  
)

export default component.exports